import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 'ZN07', label: 'Y7' },
    { value: 'ZN08', label: 'Y8' },
    { value: 'ZN09', label: 'Y9' },
    { value: 'ZN10', label: 'Y10' },
    { value: 'ZN11', label: 'Y11' },
    { value: 'ZN12', label: 'Y12' },
    { value: 'ZN13', label: 'Y13 and above' },
    { value: 'ZNAD', label: 'Advanced' },
  ],
});
